module.exports = __webpack_public_path__ + "static/media/edit.d9633c75.svg";